// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3gxWZ","title":"BackImages_title__1MTI4","images":"BackImages_images__8qVzW"};